import React from 'react'
import { ServiceCardProps } from './types'

export default function ServiceCard({
    title,
    description,
    className,
}: ServiceCardProps) {
    return (
        <li className={className}>
            <h3>{title}</h3>
            <p>{description}</p>
        </li>
    )
}
